import gql from 'graphql-tag';

const DELETE_CUSTOMER_BY_ID = gql`
  mutation deleteCustomerById($id: ID!, $deleteDevices: Boolean) {
    deleteCustomerById(id: $id, deleteDevices: $deleteDevices) {
      id
      name
    }
  }
`;

const CREATE_CUSTOMER = gql`
  mutation createCustomer($data: CreateCustomerInput!) {
    createCustomer(data: $data) {
      id
      name
      identifier
      customerCategory {
        id
        description
      }
      phoneNumbers
      email
      workspaceId
    }
  }
`;

const UPDATE_CUSTOMER_BY_ID = gql`
  mutation updateCustomerById($id: ID!, $data: UpdateCustomerInput) {
    updateCustomerById(id: $id, data: $data) {
      id
      name
      identifier
      customerCategory {
        id
        description
      }
      phoneNumbers
      email
      workspaceId
      image
      street
      city
      state
      countryId
      zipCode
    }
  }
`;

export default {
  CREATE_CUSTOMER,
  UPDATE_CUSTOMER_BY_ID,
  DELETE_CUSTOMER_BY_ID,
};
